import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('UPDATE_CP_FORM'),
  ...asyncTypes('CREATE_CP_FORM')
};

export default TYPES;
